import StripeSetup from "../models/StripeSetup";
import Chart from "../models/Chart";
import CodeSetup from '../models/CodeSetup';
import Stripe from '../models/Stripe';
import SetupOptions from '../models/SetupOptions';
import apiClient from "../components/apiClient";

export class StripeSetupService {
    static getStripeSetup(styleCode: string) : Promise<StripeSetup[]> {
        return apiClient.get<StripeSetup[]>(`/StripeSetup/GetStripeSetup/${styleCode}`).then(res => {
            return res.data});
    }
    
    static updateStripeSetup(stripeSetup: StripeSetup) : Promise<boolean> {
        return apiClient.put<boolean>(`/StripeSetup/UpdateStripeSetup`, stripeSetup).then(res => res.data);
    }

    static getStripeDetailOptions() : Promise<SetupOptions[]> {
        return apiClient.get<SetupOptions[]>(`/StripeSetup/GetStripeDetailOptions`).then(res => res.data);
    }
    
    static getStripeFabrics() : Promise<CodeSetup[]> {
        return apiClient.get<CodeSetup[]>(`/StripeSetup/GetStripeFabrics`).then(res => res.data);
    }

    static getStripeStyles() : Promise<Stripe[]> {
        return apiClient.get<Stripe[]>(`/StripeSetup/GetStripeStyles`).then(res => res.data);
    }

    static getStripeCharts() : Promise<Chart[]> {
        return apiClient.get<Chart[]>(`/StripeSetup/GetStripeCharts`).then(res => res.data);
    }

    static getWidths() : Promise<SetupOptions[]> {
        return apiClient.get<SetupOptions[]>(`/StripeSetup/GetWidths`).then(res => res.data);
    }

    static getWidthCharts() : Promise<Chart[]> {
        return apiClient.get<Chart[]>(`/StripeSetup/GetWidthCharts`).then(res => res.data);
    }

    static getColorCharts() : Promise<Chart[]> {
        return apiClient.get<Chart[]>(`/StripeSetup/GetColorCharts`).then(res => res.data);
    }
}